import generalSettings from "@apis/generalSettings";
import CardHeader from "@commons/businesscardHeader";
import Button from "@components/button";
import Fields from "@components/fields";
import Row from "@components/row";
import Typography from "@components/typography";
import Wrapper from "@components/wrapper";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

const OrderSetting = () => {
  const [exist, setExist] = useState<any>(null);
  const [initialValues, setInitialValues] = useState({
    minStatus: false,
    minAmount: "",
    freeStatus: false,
    freeAmount: "",
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await generalSettings.getByKey({
          state: "orders",
          id: "order-setting",
        });

        if (res) {
          setInitialValues({
            minStatus: res?.infos?.minimumOrder?.status ?? false,
            minAmount: res?.infos?.minimumOrder?.amount ?? "",
            freeStatus: res?.infos?.freeDelivery?.status ?? false,
            freeAmount: res?.infos?.freeDelivery?.amount ?? "",
          });
          setExist(res);
        }
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch order settings");
      }
    };
    fetchSettings();
  }, []);

  const handleSubmit = async (values: any) => {
    const payload = {
      key: "order-setting",
      group: "ordersettings",

      infos: {
        minimumOrder: {
          amount: Number(values.minAmount) || 0,
          status: values.minStatus,
        },
        freeDelivery: {
          amount: Number(values.freeAmount) || 0,
          status: values.freeStatus,
        },
      },
    };

    try {
      if (exist?.id) {
        await generalSettings.update({
          state: "orders",
          data: payload,
          id: exist.id,
        });
        toast.success("Order settings updated successfully!");
      } else {
        await generalSettings.create({
          state: "orders",
          data: payload,
        });
        toast.success("Order settings created successfully!");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to save order settings");
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({ values, setFieldValue }) => (
        <Form>
          <CardHeader title="Order Setting" />
          <Wrapper>
            <Row>
              <div style={{ flex: 1 }}>
                <Row styleRow="justify-content:space-between">
                  <Typography>Minimum Order Amount</Typography>
                  <Fields.Switch
                    name="minStatus"
                    onChange={(val) => setFieldValue("minStatus", val)}
                    styleWrapper="width:fit-content"
                  />
                </Row>
                <br />
                <Fields.Input
                  name="minAmount"
                  placeholder="Rs 500"
                  disabled={!values.minStatus}
                />
              </div>

              <div style={{ flex: 1 }}>
                <Row styleRow="justify-content:space-between">
                  <Typography>Free Delivery in Order (Rs)</Typography>
                  <Fields.Switch
                    name="freeStatus"
                    onChange={(val) => setFieldValue("freeStatus", val)}
                    styleWrapper="width:fit-content"
                  />
                </Row>
                <br />
                <Fields.Input
                  name="freeAmount"
                  placeholder="Rs 500"
                  disabled={!values.freeStatus}
                />
              </div>
            </Row>
            <br />
            <Button
              type="submit"
              title={exist ? "Update" : "Save"}
              justify="end"
            />
          </Wrapper>
        </Form>
      )}
    </Formik>
  );
};

export default OrderSetting;
